import { SkeletonBodyText, BlockStack, Box } from '@shopify/polaris';

export interface PAMetricInfoSkeletonProps {
  isShowOneLine?: boolean;
}
export const PAMetricInfoSkeleton: React.FC<PAMetricInfoSkeletonProps> = ({ isShowOneLine }) => {
  if (isShowOneLine) {
    return (
      <Box width="40%">
        <SkeletonBodyText lines={1} />
      </Box>
    );
  }

  return (
    <BlockStack gap="200">
      <Box width="60%">
        <SkeletonBodyText lines={1} />
      </Box>
      <Box width="40%">
        <SkeletonBodyText lines={1} />
      </Box>
    </BlockStack>
  );
};
